import {
    init, signIn, signOut, setMe, addParam, editParam, removeParam,
} from 'stores/slices/user'
import {
    setBreadcrumb, setCommand, setMessageBar, setModal, setUrl, setTitle,
} from 'stores/slices/common'

/**
 * @typedef {object} ReduxProps
 * @property {function(import('stores/slices/user').PayloadInit):void} init Init
 * @property {function(import('stores/slices/user').PayloadMe):void} setMe setMe
 * @property {function(import('stores/slices/user').PayloadSingIn):void} signIn Sign in
 * @property {function():void} signOut Sign out
 * @property {function(import('stores/slices/user').PayloadParam):void} addParam Add param
 * @property {function(import('stores/slices/user').PayloadParam):void} editParam Edit param from constant
 * @property {function(import('stores/slices/user').PayloadParam):void} removeParam Remove param from constant
 * @property {function(import('stores/slices/common').PayloadMessageBar):void} setMessageBar Set MessageBar
 * @property {function(import('stores/slices/common').PayloadCommand):void} setCommand Set CommandBar
 * @property {function(import('stores/slices/common').PayloadBreadcrumb):void} setBreadcrumb Set Breadcrumb
 * @property {function(import('stores/slices/common').PayloadModal):void} setModal Set Modal
 * @property {function(import('stores/slices/common').PayloadUrl):void} setUrl Set Current Url
 * @property {function(import('stores/slices/common').PayloadTitle):void} setTitle Set Current title
 * @property {import('stores/slices/user').UserState["isAuthenticated"]} isAuthenticated Is user authenticated
 * @property {import('stores/slices/user').UserState["me"]} me User informations
 * @property {import('stores/slices/user').UserState["param"]} param Constants
 * @property {import('stores/slices/common').CommonState["selectedKeyURL"]} selectedKeyURL Current URL in application
 * @property {import('stores/slices/common').CommonState["messageBar"]} messageBar Messagebar
 * @property {import('stores/slices/common').CommonState["breadcrumb"]} breadcrumb Breadcrumb items
 * @property {import('stores/slices/common').CommonState["command"]} command Command items
 * @property {import('stores/slices/common').CommonState["modal"]} modal Modal
 * @property {import('stores/slices/common').CommonState["title"]} title title
 */

const mapDispatchToProps = dispatch => ({
    init: ({ me, param, lastUpdate }) => dispatch(init({ me, param, lastUpdate })),
    setMe: ({ me }) => dispatch(setMe({ me })),
    signIn: token => dispatch(signIn(token)),
    signOut: () => dispatch(signOut(undefined)),
    addParam: data => dispatch(addParam(data)),
    editParam: ({ key, value }) => dispatch(editParam({ key, value })),
    removeParam: ({ key, value }) => dispatch(removeParam({ key, value })),

    setMessageBar: ({ isDisplayed, type, message }) => dispatch(setMessageBar({ isDisplayed, type, message })),
    setCommand: commandBarItems => dispatch(setCommand(commandBarItems)),
    setBreadcrumb: data => dispatch(setBreadcrumb(data)),
    setTitle: data => dispatch(setTitle(data)),
    setModal: ({
        show, title, subTitle, callback, content,
    }) => dispatch(setModal({
        show, title, subTitle, callback, content,
    })),

    setUrl: selectedKeyURL => dispatch(setUrl(selectedKeyURL)),
})

const mapStateToProps = state => ({
    isAuthenticated: state.user.isAuthenticated,
    me: state.user.me,
    param: state.user.param,
    selectedKeyURL: state.common.selectedKeyURL,
    messageBar: state.common.messageBar,
    breadcrumb: state.common.breadcrumb,
    command: state.common.command,
    modal: state.common.modal,
    title: state.common.title,
})

export { mapDispatchToProps, mapStateToProps }
